import {
  AnyGalleryEntityVersion,
  FirestoreEntity,
  Gallery,
  Logger,
  Mapper,
  User,
} from '@uploadcam/common';
import { CollectionReference, and, getDocs, or, orderBy, query, where } from 'firebase/firestore';

export class GetTeamGalleriesInteractor {
  constructor(
    private readonly collection: CollectionReference<AnyGalleryEntityVersion>,
    private readonly logger: Logger,
    private readonly mapper: Mapper<FirestoreEntity<AnyGalleryEntityVersion>, Gallery>,
  ) {}

  /**
   * Team Gallery Managers (admins + feed managers) see every gallery in their team.
   * Everyone else sees galleries they own, contribute to, or that are open-to-team.
   * The split happens here so the Firestore rule's read predicate is never violated.
   */
  public async execute(teamId: string, user: User): Promise<Gallery[]> {
    try {
      const isManager = Gallery.isTeamGalleryManager(user);
      const q = isManager
        ? query(this.collection, where('teamId', '==', teamId), orderBy('updatedAt', 'desc'))
        : query(
            this.collection,
            and(
              where('teamId', '==', teamId),
              or(
                where('createdBy', '==', user.id),
                where('isOpenToTeam', '==', true),
                where('contributorUserIds', 'array-contains', user.id),
              ),
            ),
            orderBy('updatedAt', 'desc'),
          );

      const snap = await getDocs(q);
      return snap.docs.map((doc) => this.mapper.map(FirestoreEntity.from(doc)));
    } catch (err) {
      this.logger.error('Failed to load galleries:', err);
      throw err;
    }
  }
}
